#version 300 es
in vec2 a_position;
out vec2 v_texCoord;

void main() {
	gl_Position = vec4(a_position, 0.0, 1.0);

	// Flip Y coordinate when sampling texture
	v_texCoord = (a_position + 1.0) * 0.5;
}

